import { Pipe, PipeTransform } from '@angular/core';
import { PreparationStatutCommandes, StatutCommandes } from '@timechef/core/api';
import { ensureDate } from '@timechef/core/utils';
import { Order } from '@timechef/features/history/state/history.models';
import { isAfter } from 'date-fns';

@Pipe({
  name: 'isOrderCancelable',
  standalone: false,
})
export class IsOrderCancelablePipe implements PipeTransform {
  transform(order: Partial<Order>) {
    if (!order.scorp) return false;

    if (order.status !== StatutCommandes.ScorpNonPayee) return false;

    if (order.preparationStatus !== null && order.preparationStatus !== PreparationStatutCommandes.EnAttente) return false;

    const limitDate = order.scorp.orderLimitDate;
    return isAfter(ensureDate(limitDate), new Date());
  }
}
